import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import styled from 'styled-components';
import { BottomLeftSlot, HudSlots, TopLeftSlot, TopRightSlot, } from '../shared/HudSlots';
import { OverlayToggle } from '../shared/OverlayToggle';
import { PluginButtonTray as PrestyledPluginButtonTray } from '../shared/PluginButtonTray';
import { PluginComponentContainer } from '../shared/PluginComponentContainer';
import { PluginOverlayContainer } from '../shared/PluginOverlayContainer';
export function ViewerViewHud({ visible, fullscreenButton, }) {
    const [showPluginOverlay, setShowPluginOverlay] = useState(true);
    return (_jsxs(_Fragment, { children: [_jsxs(Hud, { "$visible": visible, children: [_jsx(TopLeftSlot, {}, "topLeftSlot"), _jsx(TopRightSlot, { children: _jsx(PluginButtonTray, { slotId: "buttonstray", hidden: !visible }) }, "topRightSlot"), _jsxs(BottomLeftSlot, { children: [_jsx(OverlayToggle, { checked: showPluginOverlay, onChange: setShowPluginOverlay }), fullscreenButton] }, "bottomLeftSlot")] }), showPluginOverlay && _jsx(PluginOverlayContainer, { slotId: "overlay" }), _jsx(PluginComponentContainer, { slotId: "components" })] }));
}
const PluginButtonTray = styled(PrestyledPluginButtonTray) `
    position: static;
    top: auto;
    left: auto;
`;
const Hud = styled(HudSlots) `
    z-index: 10;
    opacity: ${({ $visible }) => ($visible ? 1 : 0)};
    transition: opacity 0.3s ease-in-out;
    pointer-events: ${({ $visible }) => ($visible ? 'auto' : 'none')};
`;
